export const topMenuContent = (siteMapPerId, locale) => {
  if (siteMapPerId && locale) {
    return [
      siteMapPerId["features"][locale],
      siteMapPerId["download"][locale],
      siteMapPerId["support"][locale],
      siteMapPerId["pricing"][locale],
      siteMapPerId["upgrade"][locale],
      siteMapPerId["company"][locale],
    ];
  } else {
    return []
  }
};
